import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { openOrdersFromDashboard } from "../dashboardSearch";
import {
  threeDotIcon,
  PinIcon,
  actionNotesIcon,
  actionOrderIcon,
  actionChartIcon,
  actionDollarIcon,
  actionDropDownCalenderIcon,
  actionDropDownChatIcon,
  actionDropDownSchedulerIcon,
  PinIconFilled,
  vitalsicon,
  Intakeicon,
} from "./svgs";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../reduxtoolkit/userconfigslice";
import api from "../../api/api";
import PushPinIcon from '@mui/icons-material/PushPin';
import { eventBus } from "../../utils/eventBus";
import { clearChartStartTab, requestChartStartTab } from "../../utils/chartStartTab";
import { cardActionShown, getPracticeId } from "../../config/practice";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import { practiceFeatures } from "../../config/practice";
import { useSendFormsWizard } from "../../forms/staff/launch";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import { useStaffFormFill } from "../../forms/internal/launch";
const DropdownMenu = ({
  searchTerm,
  openPaymentModal,
  openNoteModal,
  modalopen,
  insertdata,
  isOpen,
  setIsOpen,
  isSameDate,
  data,
    setToastSeverity,
  setToastMessage,
  setOpenToast,
  setChat,
  homescreenprev = [],
  viewMode,
  type,
  loc,
  rail = false, // redesigned card's action rail: match its .act buttons (opt-in; other callers unchanged)
  setSelectedCard,
  handleschedular
}) => {
  const dropdownRef = useRef(null);
  const iconRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
 const location = useLocation();
  const userConfig = useSelector((state) => state.userconfig);
  const dashPins = userConfig?.config?.dash_pins || [];
  const practiseid = getPracticeId();
  // Form Wizard: "Send Forms" (id 10) opens it for this row's patient/visit.
  const [openSendForms, sendFormsWizard] = useSendFormsWizard();
  // Internal staff forms: "Staff Form" (id 11) fills one for this row's patient.
  const [openStaffForm, staffFormFill] = useStaffFormFill();

  const toggleDropdown = () => setIsOpen((prev) => !prev);
const handlePinRemove = async (optionId) => {
  if (!userConfig?.id) return;
  // 🔒 minimum 3 pins rule
  if (dashPins.length <= 3) {
    return; // do nothing
  }

  const updatedPins = dashPins.filter((id) => id !== optionId);

  try {
    await api.put(`/v1/${practiseid}/user/config`, {
      rowid: userConfig.id,
      dash_pins: updatedPins,
    });

    dispatch(
      setConfig({
        ...userConfig,
        config: { ...userConfig.config, dash_pins: updatedPins },
      })
    );
  } catch (err) {
    console.error("Failed to update config", err);
  }
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePinAdd = async (optionId) => {
    if (!userConfig?.id) return;

    let updatedPins = [...dashPins];
if (!updatedPins.includes(optionId)) {
  if (loc !== "exp" && updatedPins.length >= 3) {
    updatedPins.shift(); // remove oldest ONLY when not exp
  }
  updatedPins.push(optionId);
}


    try {
      await api.put(`/v1/${practiseid}/user/config`, {
        rowid: userConfig.id,
        dash_pins: updatedPins,
      });

      dispatch(
        setConfig({
          ...userConfig,
          config: { ...userConfig.config, dash_pins: updatedPins },
        })
      );
    } catch (err) {
      console.error("Failed to update config", err);
    }
  };
// disabled: !isSameDate, disabledLabel: "No Orders"
  const dropdownOptions = [
    { id: 1, key: "Chart", icon: actionChartIcon, label: "Charts", onClick: () => { clearChartStartTab(); modalopen(data.id); }, visible: homescreenprev.includes("Chart") },
    { id: 2, key: "Order", icon: actionOrderIcon, label: "Orders", onClick: () => {
if(!isSameDate){
setToastMessage('Please schedule an appointment')
setToastSeverity('info')
setOpenToast(true)
return
}
       openOrdersFromDashboard(navigate, location, data, searchTerm)}, visible: homescreenprev.includes("Order"),visable:true },
    { id: 3, key: "Notes", icon: actionNotesIcon, label: "Notes", onClick: openNoteModal, visible: homescreenprev.includes("Notes") },
    { id: 4, key: "Take Payment", icon: actionDollarIcon, label: "Payments", onClick: openPaymentModal, visible: homescreenprev.includes("Take Payment") },
    { id: 5, key: "Imaging", icon: actionDropDownCalenderIcon, label: "Imaging", onClick: () => insertdata(data), visible: true },
    {
          id: 6,
          key: "Chat",
          icon:actionDropDownChatIcon,
          label: "Chat",
             onClick: () =>{
        setSelectedCard(data);
        setChat(true)},
          visible: true,
        },
            {
          id: 7,
          key: "Scheduler",
          icon:actionDropDownSchedulerIcon,
          label: "Scheduler",
     onClick: () => {
        setSelectedCard(data);
      handleschedular(data)
      },
          visible: true,
        },
        {
              id: 8,
              key: "Vitals",
              icon: vitalsicon,
              label: "Vitals",
             onClick: () => {
  requestChartStartTab(data.patientid, 3); // opens on Vitals (utils/chartStartTab.js)
  modalopen(data.id);

  setTimeout(() => {
    eventBus.emit("navigateToPriorVitals", { tab: 3, internalTab:1});
  }, 50); // or 100ms if needed
} ,
              visible: homescreenprev.includes("Chart"),
            },
            {
                  id: 9,
                  key: "Intake",
                  icon: Intakeicon,
                  label: "Intake",
                onClick: () => {
              requestChartStartTab(data.patientid, 3); // opens on Vitals (utils/chartStartTab.js)
              modalopen(data.id);
            
              setTimeout(() => {
                eventBus.emit("navigateToPriorVitals", { tab: 3 ,internalTab:0});
              }, 50); // or 100ms if needed
            } ,
                  visible: homescreenprev.includes("Chart"),
                },
    {
      // Form Wizard (practiceFeatures().formWizard).
      id: 10,
      key: "Send Forms",
      icon: <PostAddOutlinedIcon sx={{ fontSize: 18 }} />,
      label: "Send Forms",
      onClick: () => {
        setIsOpen(false);
        openSendForms(data);
      },
      visible: practiceFeatures().formWizard,
    },
    {
      // Internal staff forms (practiceFeatures().staffForms).
      id: 11,
      key: "Staff Form",
      icon: <NoteAltOutlinedIcon sx={{ fontSize: 18 }} />,
      label: "Staff Form",
      onClick: () => {
        setIsOpen(false);
        openStaffForm(data);
      },
      visible: practiceFeatures().staffForms,
    },
  ];

  // Sort: unpinned (showing pin) first, then pinned
  const sortedOptions = dropdownOptions
    // The practice's card action allowlist (7825: Notes, Take Payment,
    // Scheduler, Intake; 9928: every action).
    .filter((opt) => opt.visible && cardActionShown(opt.key))
    .sort((a, b) => {
      const aPinned = dashPins.includes(a.id);
      const bPinned = dashPins.includes(b.id);
      if (aPinned === bPinned) return 0;
      return aPinned ? 1 : -1; // unpinned first
    });

  return (
    <div className="relative inline-block">
      <div className="relative group">
        <button
          ref={iconRef}
          onClick={toggleDropdown}
          className={rail ? `act${isOpen ? " on" : ""}` : `h-[56px] w-[56px] ${
            isOpen ? "bg-[#1D2951] text-white" : "bg-[#F9FAFB] text-[#4B5563]"
          } flex justify-center items-center rounded-[12px] cursor-pointer hover:bg-[#1D2951] hover:text-white focus:outline-none`}
        >
          {threeDotIcon}
        </button>
        {type === "under" ? (
          <span className="absolute top-[60px] left-1/2 -translate-x-1/2 bg-[#1D2951] text-white text-xs font-medium py-1 px-2 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap">
            Actions
          </span>
        ) : (
          <span className={`absolute ${rail ? "right-[60px] z-10" : "left-[60px]"} top-1/2 -translate-y-1/2 bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap shadow-md`}>
            Actions
          </span>
        )}
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute right-[60px] bottom-[0px] z-30 w-56 origin-top-right rounded-xl bg-white ring-1 shadow-md ring-black/5 focus:outline-hidden"
          role="menu"
          aria-orientation="vertical"
          tabIndex="-1"
        >
          <div role="none">
            {sortedOptions.map((opt, idx, arr) => (
              <div
                key={opt.key}
                onClick={() => {
                  if (!opt.disabled) opt.onClick();
                }}
                className={`flex items-center justify-between gap-3 px-4 py-2 text-sm cursor-pointer ${
                  opt.disabled ? "text-red-500" : "text-gray-700"
                } hover:bg-[#E17954] hover:text-white ${
                  idx === 0
                    ? "rounded-t-xl"
                    : idx === arr.length - 1
                    ? "rounded-b-xl"
                    : ""
                }`}
              >
                <div className="flex items-center gap-3">
                  <span>{opt.icon}</span>
                  <span>{opt.disabled ? opt.disabledLabel : opt.label}</span>
                </div>

                {/* Show pin only if NOT already pinned and not disabled */}
                {!dashPins.includes(opt.id) && !opt.disabled ? (
                  <span
                    className="text-[#D9D9D9] group-hover:text-white transition-colors duration-200 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePinAdd(opt.id);
                    }}
                  >
                    {PinIcon}
                  </span>
                ):<><span     onClick={(e) => {
      if (loc !== "exp") return;
      e.stopPropagation();
      handlePinRemove(opt.id);
    }}
    title={loc === "exp" ? "Unpin" : ""}   className="text-[#D9D9D9] group-hover:text-white transition-colors duration-200 cursor-pointer">{PinIconFilled}</span></>}
              </div>
            ))}
          </div>
        </div>
      )}
      {sendFormsWizard}
      {staffFormFill}
    </div>
  );
};

export default DropdownMenu;
